import * as yup from "yup";

export function onlyIfFieldIsVisible(
  this: yup.AnySchema,
  validator: yup.AnySchema
): yup.AnySchema {
  return this.test("only-if-field-is-visible", function (val) {
    if (val === undefined) {
      return true;
    }

    try {
      validator.validateSync(val);
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return this.createError({ message, path: this.path });
    }
  });
}

export function onlyIfPeselFieldIsVisible(
  this: yup.AnySchema,
  validator: yup.AnySchema
): yup.AnySchema {
  return this.test("only-if-pesel-field-is-visible", function (val) {
    const { lackOfPesel } = this.parent;

    if (val === undefined || lackOfPesel) {
      return true;
    }

    try {
      validator.validateSync(val);
      return true;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return this.createError({ message, path: this.path });
    }
  });
}
